var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    fillRule: "evenodd",
    d: "M8.3 4.162c3.76-3.939 7.431 1.887 1.812 2.83 5.619.985 1.903 6.77-1.812 2.831 1.903 4.923-5.483 4.882-3.58 0-3.76 3.939-7.431-1.846-1.812-2.83C-2.756 6.048.959.263 4.72 4.161c-1.948-4.883 5.483-4.883 3.58 0m-1.813.524C7.972 4.686 8.3 6.04 8.3 6.45s0 2.204-1.813 2.204-1.95-.882-1.95-2.204c0-1.516 1.497-1.763 1.95-1.763",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFlower);
export default __webpack_public_path__ + "static/media/footerFlower.ba487ada930b724993b6fbfb08349021.svg";
export { ForwardRef as ReactComponent };